<div class="mc-view-login">
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <img class="mc-logo" src="assets/images/logo.png" />
      </div>
    </div>
  </nav>

  <div class="login-box">
    <form name="theForm" class="ssp-form" autocomplete="off" autocorrect="off" spellcheck="false" novalidate>
      <legend>
        <span>{{ 'label_SSP' | xsI18n }}</span>
      </legend>
      <div class="login-error-message" *ngIf="message">
        {{ message }}
      </div>
      <div class="input-fields">
        <div class="form-group">
          <i class="fa fa-user"></i>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="username"
            #username_check="ngModel"
            name="username"
            required
            placeholder="{{ 'label_Username' | xsI18n }}"
          />
          <!-- <div class="label-title">{{ 'label_Username' | xsI18n}}</div> -->
          <div *ngIf="username_check.invalid && username_check.touched" class="error-labels">
            <div class="label-invalid">{{ 'message_MandatoryField' | xsI18n }}</div>
          </div>
        </div>
        <div class="form-group">
          <i class="fa fa-key"></i>
          <input
            type="password"
            class="form-control"
            [(ngModel)]="password"
            #password_check="ngModel"
            name="password"
            required
            placeholder="{{ 'label_Password' | xsI18n }}"
          />
          <!-- <div class="label-title">{{ 'label_Username' | xsI18n}}</div> -->
          <div *ngIf="password_check.invalid && password_check.touched" class="error-labels">
            <div class="label-invalid">{{ 'message_MandatoryField' | xsI18n }}</div>
          </div>
        </div>
      </div>
      <div class="login-btn">
        <button class="btn btn-primary" (click)="onLogin()" ngDisabled="theForm.$invalid || loginDisabled">
          <span *ngIf="!isProcessing"> {{ 'label_Login' | xsI18n }} </span>
          <span class="loading-icon fa fa-circle-o-notch fa-spin" *ngIf="isProcessing"></span>
        </button>
      </div>
    </form>
  </div>

  <div class="footer">
    <div class="footer-content">
      <span>{{ 'label_PoweredBy' | xsI18n }}</span
      ><i class="fa famc famc-soti-logo"></i>
    </div>
  </div>
</div>
